// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24nFt","content":"styles_content__y2bmC","row":"styles_row__3PkxL","footer":"styles_footer__30lGw","phraseLength":"styles_phraseLength__3WlQA"};